export default {
    intro: `Seed Letters are the smallest elements that make up words.<br />
            Let's explore the relationships between words made from Seed Letters and characters. `,
    options: {
        textbook: 'Words from textbook',
        page: 'Textbook',
    },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `${round === 1 ? 'First' : 'Second'} Letter`;
        },
        title: {
            word: 'Letter',
            example1: 'Example Word 1',
            example2: 'Example Word 2',
            check: 'Review Learned Words',
            question: 'Word Question',
            meaning: 'Check Semantic Relationship',
            meaningQuestion: 'Semantic Relationship Question',
        },
    },
    indicator: {
        word: 'Learn the shape, sound, and meaning of the Seed Letter.',
        example1: 'Learn two words that contain the Seed Letter.',
        example2: 'Learn how the Seed Letter is used in words.',
        question: 'Which of the two words uses the "{ reading }" letter?',
        meaning: 'Learn how the Seed Letter is used in words.',
        meaningQuestion: 'What is the semantic relationship between the two Seed Letters?',
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? 'This is a section where Students spin the cubes to learn on their own.'
                : 'Try spinning the cubes yourself to learn the letters.';
        },
    },
    result: {
        correct: 'Correct',
        incorrect: 'Incorrect',
        selected: 'Selected',
    },
    buttons: {
        next: 'Next',
    },
    study: {
        example: 'Example Sentence',
        meaning: 'Meaning',
    },
};
